const PIXEL_ID = '1491175535478029'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export function initFbPixel() {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  /* eslint-disable */
  ;(function (f: any, b: any, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e)
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Sueño para BB en 7 Minutos',
      currency: 'USD',
      value: 6.39,
    })
  }
}
